export default __webpack_public_path__ + "static/media/or-3.2f0ff8f8.jpg";